export type LightspeedBusiness = {
  id: string
  name: string
  businessLocations: {
    id: string
    name: string
  }[]
}

export enum LightspeedMenuOrderType {
  ALL = 'ALL',
  SAMEDAY = 'SAMEDAY',
  PREORDER = 'PREORDER'
}

export const MENU_ORDER_TYPE_LABELS: Partial<
  Record<LightspeedMenuOrderType, string>
> = {
  [LightspeedMenuOrderType.SAMEDAY]: 'Same Day',
  [LightspeedMenuOrderType.PREORDER]: 'Pre-Order'
}

export const getMenuOrderType = (menu: {
  order_type?: LightspeedMenuOrderType
  orderType?: LightspeedMenuOrderType
}): LightspeedMenuOrderType | undefined => {
  const raw = menu.order_type ?? menu.orderType
  return raw
    ? ((raw as string).toUpperCase() as LightspeedMenuOrderType)
    : undefined
}

export type LightspeedStore = {
  id: string
  name: string
  store_integration_settings: {
    lightspeed_menus: {
      id: string
      name: string
      order_type?: LightspeedMenuOrderType
      orderType?: LightspeedMenuOrderType
    }[]
    lightspeed_order_profile_mapping: {
      delivery: string | null
      pickup: string | null
      orderAtTable: string | null
    }
    lightspeed_business_id: string
    lightspeed_business_name: string
    lightspeed_business_location_id: string
    lightspeed_business_location_name: string
    lightspeed_last_menu_push_at: string
    lightspeed_scheduled_order_buffer_sameday_minutes: number | null
    lightspeed_scheduled_order_buffer_preorder_minutes: number | null
  }
}

export const getConnectedLightspeedStores = (
  stores: LightspeedStore[]
): LightspeedStore[] =>
  stores.filter(
    (store) => !!store.store_integration_settings.lightspeed_business_id
  )

export type LightspeedMenu = {
  id: string
  name: string
}

export type LightspeedOrderProfile = {
  code: string
  deliveryMode: string
}
